module.exports = __webpack_public_path__ + "2eecb97c6cbcd7e807487c94c8c9f733.pdf";